import React, { useState, useContext, useEffect } from "react";
import "../../../assests/css/generals/Chatpage.css";
import { useParams } from "react-router-dom";
import axios from "axios";
import { AppContext } from "../../../context/Appcontext";

const ChatPage = () => {
    const { conversationId } = useParams();
    const [message, setMessage] = useState("");
    const [messages, setMessages] = useState([]);
    const { baseUrl } = useContext(AppContext);

    const sendMessage = () => {
        const student = JSON.parse(localStorage.getItem("student"));
        if (message.trim() === "") return;
        const formData = new FormData();
        formData.append("conversation_id", conversationId);
        formData.append("sender_id", student.id);
        formData.append("sender_role", "student");
        formData.append("message", message);

        axios.post(`${baseUrl}/chat/sendMessage`, formData)
            .then((response) => {

                if (response.data.success) {
                    setMessage("");
                    fetchMessages();
                }
            });

    };
    const fetchMessages = () => {
        const formData = new FormData();
        formData.append("conversation_id", conversationId);
        axios
            .post(`${baseUrl}/chat/getMessages`, formData)
            .then((response) => {
                console.log(response.data.messages);
                if (response.data.success) {
                    setMessages(response.data.messages);
                }

            });
    };
    console.log(conversationId);
    useEffect(() => {
        if (conversationId) {
            fetchMessages();
        }
    }, [conversationId]);

    return (

        <div className="chat-container">

            <div className="chat-header">

                <div>
                    <h2>Dispute Chat</h2>
                    <span>Conversation</span>
                </div>

            </div>

            <div className="chat-body">

                {
                    messages.map((msg) => (
                        <div
                            key={msg.id}
                            className={
                                msg.sender_role === "student"
                                    ? "message right"
                                    : "message left"
                            }
                        >

                            <div className="bubble">

                                <p>{msg.message}</p>

                                <small>
                                    {new Date(msg.created_at).toLocaleTimeString([], {
                                        hour: "2-digit",
                                        minute: "2-digit",
                                    })}
                                </small>

                            </div>

                        </div>
                    ))
                }

            </div>

            <div className="chat-footer">

                <input
                    type="text"
                    placeholder="Type your message..."
                    value={message}
                    onChange={(e) => setMessage(e.target.value)}
                />

                <button onClick={sendMessage}>
                    Send
                </button>

            </div>

        </div>

    );

};

export default ChatPage;